import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { HostListener } from '@angular/core';
import { allowPreviousPlayerStylesMerge } from '@angular/animations/browser/src/util';
import { PlatformLocation } from '@angular/common';
import { ApiService } from './services/api/api.service';
import { LoginRenderingService } from './services/login/login-rendering.service';
import { LocalService } from './services/utility/local.service';
import { InactivityService } from './services/utility/idle-session-expiry-service';
// import { WebSocketService } from './websocket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'DLP-Scss';
  template: string = `<img src="assets/Loader-Anim.gif"/>`;
  currentUser : any;
 // webSocketAPI: WebSocketService;
  greeting: any;
  name: string;


  constructor(private router?: Router, private location?: PlatformLocation, private data?: ApiService,private loginService? : LoginRenderingService,private  localService?: LocalService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // scroll to top
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    this.data.setTheme();
   // this.webSocketAPI = new WebSocketService(new AppComponent());
  }

  onCaptchaResolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
    // Implement your backend verification logic here
  }


  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
   let currentUser = this.loginService.currentUser;
   let json = currentUser;
    // let json = JSON.parse(localStorage.getItem('currentUser'));
    if(json){
      let url=event.srcElement.URL;
      // if(json.userId===localStorage.getItem('SSOLOGIN') && !url.includes("/login")){
      //   localStorage.removeItem('SSOLOGIN');
      //   localStorage.removeItem('currentUser');
      // }
      if(json.userId===this.localService.getSecureValue('SSOLOGIN') && !url.includes("/login")){
        this.localService.removeSecureValue('SSOLOGIN');
        localStorage.removeItem('currentUser');
      }
    }
  }

}



